import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  label: string;
  microcopy?: string;
  size?: 'md' | 'lg';
  onDark?: boolean;
  className?: string;
  href?: string;
}
const DEFAULT_MICROCOPY = 'Descarga inmediata · Garantía de 7 días · Pago seguro';
export function CtaButton({
  label,
  microcopy = DEFAULT_MICROCOPY,
  size = 'md',
  onDark = false,
  className = '',
  href = '#oferta'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'text-lg md:text-xl px-9 py-4' : 'text-base md:text-lg px-7 py-3.5';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-29" data-mp="ljmo6frikexk">
      <a href={href} className={`group inline-flex items-center justify-center gap-2 rounded-xl bg-orange font-bold text-white shadow-cta transition-transform duration-200 hover:-translate-y-0.5 hover:brightness-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange ${sizing}`} data-id="element-30" data-mp="109u00cn0mzpa">
        <span className="tracking-wide" data-id="element-31" data-mp="35xo0awkn46kf">{label}</span>
        <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="35yz7759dtufr" />
      </a>
      {microcopy && <p className={`mt-2.5 text-[13px] ${onDark ? 'text-cream/80' : 'text-ink/60'}`} data-id="element-33" data-mp="3ew9hanagrdj3">
          {microcopy}
        </p>}
    </div>;
}